































import { Component, Prop, Vue } from 'vue-property-decorator';
import Equation from '@/components/Equation.vue';
import { LandingDistanceConstraint } from '@/interfaces/constraints';

@Component({
  components: {
  Equation,
  }
  })
export default class LandingDistanceFields extends Vue {
  @Prop() constraint!: LandingDistanceConstraint;
}
